import { Component, OnInit } from '@angular/core';
import { HtmlInputType, ZiroTextConfig } from '../../../../forms/fields/text/ziro-text.component';
import { ZiroFormConfig } from '../../../../forms/ziro-forms-models';
import { IntercomButton } from '../../../models/generated/ziroModels';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

interface IntercomButtonFormData {
  extension: string;
}

@Component({
  selector: 'ziro-phone-buttons-intercom',
  templateUrl: './phone-buttons-intercom.component.html',
  imports: [ZiroFormsModule],
})
export class PhoneButtonsIntercomComponent
  extends ZiroFormAbstractDirective<IntercomButton, IntercomButtonFormData>
  implements OnInit
{
  protected _ziroFormStateService: ZiroFormStateService;

  protected formConfig: ZiroFormConfig;

  ngOnInit(): void {
    this.formConfig = {
      fields: {
        extension: {
          label: 'tkey;pages.details.phoneSettings.button.intercom.extension',
          componentConfig: new ZiroTextConfig({
            htmlInputType: HtmlInputType.TEXT,
            placeholder: this.entity.intercom?.extension,
          }),
          dataAutomation: 'phone-button-intercom-extension',
          disabled: () => true,
        },
      },
      options: {
        columnClasses: {
          label: 'col-3 text-lg-end',
          input: 'col-9',
        },
      },
    } as ZiroFormConfig;
  }

  submit(): Observable<any> {
    return this.parentSubmit$();
  }

  toFormData = (entity: IntercomButton): IntercomButtonFormData => {
    return {
      extension: entity.intercom?.extension,
    };
  };

  toEntity = (): IntercomButton => {
    // intercom is immutable
    return this.entity;
  };
}
